// @spec AUD-STR-007
'use client';

import { createFileRoute } from '@tanstack/react-router';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { AccessLogTable } from '@/features/audit/components/AccessLogTable';
import i18n from '@/lib/i18n';

export const Route = createFileRoute('/_authenticated/settings/access-log')({
  beforeLoad: () => ({
    getTitle: () => i18n.t('routeTitles.accessAuditLog'),
  }),
  component: AccessLogPage,
});

/**
 * Access audit log page displaying who accessed what resources.
 *
 * Features:
 * - Focused view of access, export, and access_denied events
 * - Filter by sensitivity level (low, medium, high, critical)
 * - Toggle to show/hide exports and denied access
 * - Flag indicator for unusual access patterns
 * - Real-time polling with 5-second refresh
 * - Accessible to org:admin and org:compliance_officer roles
 */
function AccessLogPage() {
  const { t } = useTranslation('settings');
  const [search, setSearch] = React.useState('');

  return (
    <div className="p-8">
      <div className="mx-auto max-w-7xl space-y-6">
        <header>
          <h1 className="text-3xl font-semibold text-foreground">{t('accessLogPage.title')}</h1>
          <p className="mt-1 text-muted-foreground">{t('accessLogPage.description')}</p>
        </header>

        <AccessLogTable search={search} onSearchChange={setSearch} />
      </div>
    </div>
  );
}
